"use strict";

import "flickity/dist/flickity.min.css";
import Flickity from "flickity";
import "flickity-imagesloaded";
import "/src/css/index.scss";

import Menu from "./modules/Menu";
import CategoryFilters from "./modules/CategoryFilters";
import ScrollToAnchorSmoothly from "./modules/ScrollToAnchorSmoothly";

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
  import.meta.hot.accept(() => {
    console.log("HMR");
  });
}

// Generate random number within a range
function getRandomIntInclusive(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Check if elements are in view
function elementsInView(e) {
  // let windowHeight;
  let elements = document.querySelectorAll(e);

  function checkPosition() {
    elements.forEach((element) => {
      let positionFromTop = element.getBoundingClientRect().top;

      if (positionFromTop - window.innerHeight <= 0) {
        element.classList.add("in-view");
      }
    });
  }

  window.addEventListener("scroll", checkPosition);

  checkPosition();
}

function setupSliders() {
  let sliders = document.querySelectorAll(".slider");

  sliders.forEach(function (slider, index) {
    let t = getRandomIntInclusive(4000, 7000);

    let flkty = new Flickity(slider, {
      cellAlign: "left",
      contain: true,
      imagesLoaded: true,
      lazyLoad: 2,
      wrapAround: true,
      prevNextButtons: false,
      autoPlay: t,
      draggable: true,
      pageDots: false,
    });
  });
}

function projectSlider() {
  if (document.querySelector(".project-gallery-slider")) {
    let flkty = new Flickity(".project-gallery-slider", {
      cellAlign: "left",
      contain: true,
      imagesLoaded: true,
      //lazyLoad: 2,
      pageDots: true,
      draggable: true,
    });
  }
}

function headline() {
  if (document.querySelector(".headline")) {
    let headline = document.querySelector(".headline");
    let closeButton = document.querySelector(".headline-close");
    closeButton.addEventListener("click", function (event) {
      event.preventDefault();
      headline.classList.add("headline--hidden");
    });
  }
}

function enquiryType() {
  let dropdown = document.querySelector("#enquiry_type");
  let professional = document.querySelector("#professional");
  dropdown.addEventListener("input", function (event) {
    console.log("!");
    if (event.target.value === "professional") {
      professional.style.display = "block";
    } else {
      professional.style.display = "none";
    }
  });
}

class nigelcoates {
  constructor() {
    this.init();
  }

  init() {
    setupSliders();
    elementsInView(".slider,.project-gallery-wrap");
    headline();
    projectSlider();
    this.initTabs();

    if (document.querySelector("#enquiry_type")) {
      enquiryType();
      //validateEnquiry();
    }

    const menu = new Menu();

    const categoryFiltersModules = document.querySelectorAll(".js-filters");
    if (!!categoryFiltersModules) {
      categoryFiltersModules.forEach(
        (categoryFiltersModule) => new CategoryFilters(categoryFiltersModule)
      );
    }

    const anchors = document.querySelectorAll('a[href*="#"]:not([href="#"])');
    if (!!anchors) {
      anchors.forEach((anchor) => new ScrollToAnchorSmoothly(anchor));
    }
  }

  // Initialize tabs functionality
  initTabs() {
    // Handle both .tabs containers and standalone tab interfaces
    const tabContainers = document.querySelectorAll('.tabs');
    const standaloneTabLists = document.querySelectorAll('[role="tablist"]');
    
    // Process traditional .tabs containers
    tabContainers.forEach(container => {
      const tabs = container.querySelectorAll('[role="tab"]');
      const panels = container.querySelectorAll('[role="tabpanel"]');
      
      this.setupTabInteractions(tabs, panels);
    });
    
    // Process standalone tab interfaces (like clients page)
    standaloneTabLists.forEach(tabList => {
      // Skip if already processed as part of .tabs container
      if (tabList.closest('.tabs')) return;
      
      const tabs = tabList.querySelectorAll('[role="tab"]');
      const panels = document.querySelectorAll('[role="tabpanel"]');
      
      this.setupTabInteractions(tabs, panels);
    });
  }

  // Setup tab interactions for a set of tabs and panels
  setupTabInteractions(tabs, panels) {
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();
        this.activateTab(tab, tabs, panels);
      });
      
      tab.addEventListener('keydown', (e) => {
        this.handleTabKeydown(e, tabs, panels);
      });
    });
  }

  // Activate a specific tab
  activateTab(activeTab, allTabs, allPanels) {
    const activeIndex = Array.from(allTabs).indexOf(activeTab);
    
    // Update tabs
    allTabs.forEach((tab, index) => {
      const isActive = index === activeIndex;
      tab.setAttribute('aria-selected', isActive);
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      tab.classList.toggle('active', isActive);
    });
    
    // Update panels
    allPanels.forEach((panel, index) => {
      const isActive = index === activeIndex;
      panel.classList.toggle('active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
    
    // Update hero image if data attributes exist
    this.updateHeroImage(activeTab);
    
    // Dispatch custom event for tab activation
    const tabActivatedEvent = new CustomEvent('tabActivated', {
      detail: { tab: activeTab, index: activeIndex }
    });
    document.dispatchEvent(tabActivatedEvent);
    
    // Focus the active tab
    activeTab.focus();
  }

  // Update hero image based on tab data attributes
  updateHeroImage(activeTab) {
    const heroImage = document.getElementById('clients-hero-image');
    if (!heroImage) return;
    
    // Get image URLs from data attributes
    const webp1x = activeTab.getAttribute('data-image-webp-1x');
    const webp2x = activeTab.getAttribute('data-image-webp-2x');
    const jpeg1x = activeTab.getAttribute('data-image-jpeg-1x');
    const jpeg2x = activeTab.getAttribute('data-image-jpeg-2x');
    const alt = activeTab.getAttribute('data-image-alt');
    
    // Only proceed if image data exists
    if (!webp1x || !jpeg1x) return;
    
    // Update picture sources
    const webpSource = heroImage.querySelector('source[type="image/webp"]');
    const jpegSource = heroImage.querySelector('source[type="image/jpeg"]');
    const img = heroImage.querySelector('img');
    
    if (webpSource) {
      webpSource.srcset = `${webp1x} 1x, ${webp2x} 2x`;
    }
    
    if (jpegSource) {
      jpegSource.srcset = `${jpeg1x} 1x, ${jpeg2x} 2x`;
    }
    
    if (img) {
      img.src = jpeg1x;
      if (alt) {
        img.alt = alt;
      }
    }
  }

  // Handle keyboard navigation for tabs
  handleTabKeydown(e, tabs, panels) {
    const currentIndex = Array.from(tabs).indexOf(e.target);
    let targetIndex;
    
    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        targetIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
        this.activateTab(tabs[targetIndex], tabs, panels);
        break;
        
      case 'ArrowRight':
        e.preventDefault();
        targetIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
        this.activateTab(tabs[targetIndex], tabs, panels);
        break;
        
      case 'Home':
        e.preventDefault();
        this.activateTab(tabs[0], tabs, panels);
        break;
        
      case 'End':
        e.preventDefault();
        this.activateTab(tabs[tabs.length - 1], tabs, panels);
        break;
    }
  }
}

(function () {
  document.addEventListener("touchstart", function () {}, true);
  new nigelcoates();
})();
